/* RESPONSIBLE TEAM: team-standalone */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { taskFor } from 'ember-concurrency-ts';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import { type TaskInstance } from 'ember-concurrency';
import { StandalonePlatform } from 'embercom/objects/standalone/constants';
import { ReactRoute } from 'embercom/lib/react-route';

class IntegrationRoute extends Route {
  @service declare appService: {
    app: {
      hasStandalonePlatform(platform: string): boolean;
      canStandalonePlatformAccessReactIntegrationPages: boolean;
    };
  };
  @service declare finStandaloneService: FinStandaloneService;

  reactEnabled() {
    return this.appService.app.canStandalonePlatformAccessReactIntegrationPages;
  }

  async beforeModel() {
    let promises: TaskInstance<void>[] = [];

    if (this.appService.app.hasStandalonePlatform(StandalonePlatform.Salesforce)) {
      if (this.finStandaloneService.salesforceDataLoader.isLoadingSalesforceLiveChatConfig) {
        promises.push(
          taskFor(this.finStandaloneService.salesforceDataLoader.loadSalesforceLiveChatConfig)
            .lastRunning!,
        );
      } else {
        promises.push(
          taskFor(
            this.finStandaloneService.salesforceDataLoader.loadSalesforceLiveChatConfig,
          ).perform(),
        );
      }

      if (this.finStandaloneService.salesforceDataLoader.isLoadingSalesforceInAppMessagingConfig) {
        promises.push(
          taskFor(this.finStandaloneService.salesforceDataLoader.loadSalesforceInAppMessagingConfig)
            .lastRunning!,
        );
      } else {
        promises.push(
          taskFor(
            this.finStandaloneService.salesforceDataLoader.loadSalesforceInAppMessagingConfig,
          ).perform(),
        );
      }

      if (this.finStandaloneService.salesforceDataLoader.isLoadingSalesforceDataFields) {
        promises.push(
          taskFor(this.finStandaloneService.salesforceDataLoader.loadSalesforceDataFields)
            .lastRunning!,
        );
      } else {
        promises.push(
          taskFor(
            this.finStandaloneService.salesforceDataLoader.loadSalesforceDataFields,
          ).perform(),
        );
      }
    }

    if (this.appService.app.hasStandalonePlatform(StandalonePlatform.Freshdesk)) {
      if (this.finStandaloneService.isLoadingFreshdeskConfig) {
        promises.push(taskFor(this.finStandaloneService.loadFreshdeskConfig).lastRunning!);
      } else {
        promises.push(taskFor(this.finStandaloneService.loadFreshdeskConfig).perform());
      }
    }

    await Promise.all(promises);
  }
}

export default ReactRoute(IntegrationRoute);
